import {
  DAY_MS,
  HOUR_MS,
  MINUTE_MS,
  MONTH_MS,
  YEAR_MS
} from '@anm/constants/date';

const getPassedTime = (date: number) => {
  const oneMinute = MINUTE_MS;
  const oneHour = HOUR_MS;
  const oneDay = DAY_MS;
  const oneMonth = MONTH_MS;
  const oneYear = YEAR_MS;
  const eventTimeStamp = new Date(date).getTime();

  const currentTimeStamp = Date.now();
  const leftTimeOrigin = currentTimeStamp - eventTimeStamp;
  const leftTime = leftTimeOrigin > 1000 ? leftTimeOrigin : 1000;

  const leftMonthsInMilliseconds = leftTime % oneYear;
  const leftDaysInMilliseconds = leftMonthsInMilliseconds % oneMonth;
  const leftHoursInMilliseconds = leftDaysInMilliseconds % oneDay;
  const leftMinutesInMilliseconds = leftHoursInMilliseconds % oneHour;
  const leftSecondsInMilliseconds = leftMinutesInMilliseconds % oneMinute;

  const leftYears = Math.floor(leftTime / oneYear);
  const leftMonths = Math.floor(leftMonthsInMilliseconds / oneMonth);
  const leftDays = Math.floor(leftDaysInMilliseconds / oneDay);
  const leftHours = Math.floor(leftHoursInMilliseconds / oneHour);
  const leftMinutes = Math.floor(leftMinutesInMilliseconds / oneMinute);
  const leftSeconds = Math.floor(leftSecondsInMilliseconds / 1000);

  const setPassedTime = (time: number, periodKey: string) => {
    const calcPeriodKey = time > 1 ? `${periodKey}s` : periodKey;
    const period = calcPeriodKey;
    return `${time} ${period} ago`;
  };

  if (leftYears) return setPassedTime(leftYears, 'year');
  if (leftMonths) return setPassedTime(leftMonths, 'month');
  if (leftDays) return setPassedTime(leftDays, 'day');
  if (leftHours) return setPassedTime(leftHours, 'hour');
  if (leftMinutes) return setPassedTime(leftMinutes, 'minute');
  if (leftSeconds) return setPassedTime(leftSeconds, 'second');
};

export default getPassedTime;
